import barDefaultConfig from '../../theme/bar';
import { isType } from '../../utils/util';
export default function (series) {
  var barStack = {};
  series.forEach(function (chartOpt, idx) {
    if (!isType(chartOpt, 'bar')) return;
    var stack = chartOpt.stack;
    var stackName;

    if (stack) {
      stackName = stack;
    } else {
      stackName = "custom-bar-stack-" + idx;
    }

    if (!barStack[stackName]) barStack[stackName] = [];
    barStack[stackName].push(chartOpt);
    var stacks = Object.keys(barStack);
    var barWidth = parseFloat(barDefaultConfig.barWidth) / stacks.length + "%";
    stacks.map(function (stackName) {
      barStack[stackName].forEach(function (bar) {
        bar.barWidth = barWidth;
      });
    });
  });
}